import { trakrefFontFamily } from "../../../utils";
import { Grey1 } from "../../../color_utils";
import { isMobile } from "../../../utils";

export const locationLabelStyle = {
    width: '100%',
    flexShrink: 0,
    color: "#00859B",
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: trakrefFontFamily
};

export const cylinderLabelStyle = {
    color: '#000000',
    fontFamily: trakrefFontFamily,
    fontSize: '18px'
};

export const listStyle = {
    // maxHeight: '30vh',
    // overflow: 'auto',
};

export const closeButtonStyle = {
    position: 'relative',
    marginLeft: '99%',
    padding: 0
};

export const reweighButton = {
    color: '#00859B',
    fontFamily: trakrefFontFamily,
    fontSize: '12px',
    border: '1px solid #00859B',
    padding: '2% 10%',
    fontWeight: 600,
};

export const selectCylinderStyle = {
    fontFamily: trakrefFontFamily,
    color: Grey1,
    fontSize: '13px',
    marginLeft: '1vw'
};

export const searchBarStyle = {
    '& .MuiInputBase-input': { padding: '6.5px 14px' },
    ...(isMobile && { width: '100%' }),
};

export const filterListOptions = [
    { type: 'dropdown', property: 'assetType', name: 'Cylinder Type' }
];

export const filterOptionColumns = [
    { type: "dropdown", name: "Asset Type", property: "assetType", translateId: "serviceEventView.assetDetailInfo.asset-type" },
    { type: "dropdown", name: "Material Type", property: "materialType", translateId: "serviceEventView.assetDetailInfo.material-type" },
    { type: "text", name: "Gas Capacity", property: "maxGasCapacityLbs", translateId: "rapidCylinderEntry.cylinderInputForm.gas-capacity" },
    { type: "text", name: "Current Gas Weight", property: "currentGasWeightLbs", translateId: "rapidCylinderEntry.current-Gas-Weight" },
    { type: "text", name: "Tag Number", property: "tagNumber", translateId: "rapidCylinderEntry.cylinderInputForm.tag-number" },
    { type: "date", name: "Acquisition Date", property: "acquisitionDate", translateId: "assetDetailsMainTab.acquisition-date" },
];